import {
  verifyCallsRuntime,
} from './CallsRuntimeVerificationEngine';

export type CallsCommandCenterStatus =
  | 'healthy'
  | 'warning';

export interface CallsCommandCenterFeedResult {
  readonly governor: 'Calls Governor';
  readonly domain: 'communications';
  readonly lifecycle: 'command-center-feed';
  readonly status: CallsCommandCenterStatus;
  readonly verified: boolean;
  readonly communicationAuthoritiesVerified: number;
  readonly sessionsVerified: number;
  readonly connectionsVerified: number;
  readonly evidenceCapturedAt: string;
}

export function getCallsCommandCenterFeed():
CallsCommandCenterFeedResult {
  const verification =
    verifyCallsRuntime();

  return Object.freeze({
    governor: 'Calls Governor',
    domain: 'communications',
    lifecycle: 'command-center-feed',
    status:
      verification.passed
        ? 'healthy'
        : 'warning',
    verified:
      verification.passed,
    communicationAuthoritiesVerified:
      verification.communicationAuthoritiesVerified,
    sessionsVerified:
      verification.sessionsVerified,
    connectionsVerified:
      verification.connectionsVerified,
    evidenceCapturedAt:
      verification.verifiedAt,
  });
}
